const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'form',
    ],

    config: {
        entityContext: '',
        resourceRegisterKey: 'parentEntityForProperties',
        updateTabTitleForFieldCodes: false, // define fields to update the identified tabTitle. sanitize them within the corresponding controller first.
        updateTabTitleControllerLocator: '< templates_core_controller_controller', // defines how to find the actual controller
        updateTabTitleTabContentLocator: '< base_tabStrip_tabContent', // defines how to find the actual tabContent
    },

    methods: {
        prepare(storage, isServer){
            // preset dirtyAttributes defined by parent (usually a controller).
            // e.g., showInsert_customerContacts: the properties form has to know it's customerID
            const dirtyAttributesForProperties = this.getResourceRegisterContent('dirtyAttributesForProperties')

            if(!utils.isEmpty(dirtyAttributesForProperties)){
                utils.refMerge(this.model.dirtyFields, {
                    data: {
                        attributes: dirtyAttributesForProperties
                    }
                })
            }

            this.onPrepareDone(storage, isServer)
        },

        onPrepareDone(storage, isServer){
            // NOTE: overwrite if necessary
        },

        /**
         * this function will be called after the response of a submit request has returned.
         *
         * @param   response        {} - server response
         * @param   insertionDone   boolean - has an insert been performed or not
         */
        onSubmit: function(response, insertionDone){
            // NOTE: this function can be overwritten by inherited form components if needed
            let modalFound = false
            this.closest('base_modal_modal', modal => {
                modalFound = true
            })
            // forms in modals will be closed right after submit anyway.
            if(!modalFound){
                this.refresh()
            }
        },

        /**
         * this function will be called after the form values has been changed.
         *
         * @param isRelationChange 		boolean - was the change related to a relation or not
         * @param changeDone 			boolean - has a change been done
         * @param fieldData 			{} - fieldData used to define what to do
         */
        onChange: function(isRelationChange, changeDone, fieldData){
            fieldData = fieldData || {}
            if(!this.config.creationMode && (this.config.updateTabTitleForFieldCodes || {})[fieldData.fieldCode || '']){
                this.updateTabTitle()
            }
        },

        onCancel(){
            if(!this.config.creationMode) {
                this.updateTabTitle()
            }
        },

        updateTabTitle(overrideProperties){
            if(this.config.updateTabTitleForFieldCodes === false) return;

            let controller, tab, modal
            this.locate(this.config.updateTabTitleControllerLocator, controllerComponent => {
                controller = controllerComponent
            })
            this.locate(this.config.updateTabTitleTabContentLocator, tabContent => {
                tab = tabContent.getTabComponent()
            })
            this.closest('base_modal_modal', modalComponent => {
                modal = modalComponent
            })
            if(controller && tab && !modal){
                const data = {}
                for(const fieldCode in this.config.updateTabTitleForFieldCodes || {}){
                    data[fieldCode] = this.getFieldValue(fieldCode)
                }
                controller.sanitizeTabOptionsByAttributes(tab.resourceData, utils.replace(data, overrideProperties || {}), this.getFieldValue('primaryKey'), this)
                tab.refresh(false)
            }
        },

        updateKeyDownLabelValue: function(fieldCode, fieldConfig, value, callerFormFieldComponent) {
            if((this.config.updateTabTitleForFieldCodes || {})[fieldCode || '']){
                this.updateTabTitle({
                    [fieldCode]: value || ''
                })
            }
        },
    }
}